import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { http, formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/admin/PageBits";
import { ActionFormDialog, ACTION_TYPES } from "@/components/admin/ActionFormDialog";

export default function FeaturesPage() {
  const [rows, setRows] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = useCallback(() => http.get("/admin/actions").then(({ data }) => setRows(data)).catch((e) => toast.error(formatApiError(e))), []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (a, active) => {
    try { await http.put(`/admin/actions/${a.id}`, { ...a, active }); load(); } catch (e) { toast.error(formatApiError(e)); }
  };
  const remove = async (a) => {
    if (!window.confirm(`Excluir a funcionalidade "${a.name}"?`)) return;
    try { await http.delete(`/admin/actions/${a.id}`); toast.success("Funcionalidade excluída."); load(); } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-6">
      <PageHeader title="Funcionalidades" subtitle="Crie ações personalizadas. Cada funcionalidade ativa vira um botão no quadro Ações dos detalhes da solicitação.">
        <button onClick={() => setEditing({})} className="btn-gold h-9 px-4 text-sm" data-testid="feature-create-btn"><Plus className="h-4 w-4" /> Nova funcionalidade</button>
      </PageHeader>
      <div className="overflow-x-auto rounded-md border border-white/[0.06] bg-[#141C2E]">
        <Table data-testid="features-table">
          <TableHeader>
            <TableRow className="border-white/[0.06] hover:bg-transparent">
              {["Nome", "Tipo", "Título exibido ao cliente", "Ativa", ""].map((h) => <TableHead key={h} className="text-xs uppercase tracking-wider text-slate-500">{h}</TableHead>)}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 && <TableRow><TableCell colSpan={5} className="py-14 text-center text-slate-500" data-testid="features-empty">Nenhuma funcionalidade criada ainda.</TableCell></TableRow>}
            {rows.map((a) => (
              <TableRow key={a.id} className="border-white/[0.04]" data-testid={`feature-row-${a.id}`}>
                <TableCell className="text-sm text-slate-100">{a.name}</TableCell>
                <TableCell className="text-sm text-slate-400">{ACTION_TYPES[a.type]?.label}</TableCell>
                <TableCell className="text-sm text-slate-400">{a.title}</TableCell>
                <TableCell><Switch checked={a.active} onCheckedChange={(v) => toggle(a, v)} data-testid={`feature-active-${a.id}`} /></TableCell>
                <TableCell className="flex gap-1">
                  <button onClick={() => setEditing(a)} className="icon-btn" data-testid={`feature-edit-${a.id}`}><Pencil className="h-4 w-4" /></button>
                  <button onClick={() => remove(a)} className="icon-btn" data-testid={`feature-delete-${a.id}`}><Trash2 className="h-4 w-4" /></button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {editing && <ActionFormDialog action={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
    </div>
  );
}
